import React, { useState, useEffect, useRef, useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './confirmationModal.css';

const ConfirmationModalArticles = ({
  visible,
  onHide,
  children
}) => {

  return (
    /* Forma i tabela stoje jedna uz drugu, pa prozoru treba stvarna širina —
       'fit-content' ga je stezao na širinu forme. */
    <Dialog
      visible={visible}
      style={{ width: '92vw', maxWidth: '1500px', zIndex: '1000' }}
      breakpoints={{ '768px': '95vw' }}
      onHide={onHide}
      modal
      className="confirmation-modal confirmation-modal-articles"
    >
            {children}
    </Dialog>
  );
};

export default ConfirmationModalArticles;